import * as React from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { t } from 'ttag'
import './Layout.scss'
import { scrollToTop } from '../../common/helpers/scroll'
import { MAPPED_ROUTES, ROUTES } from '../../common/Routes/routePaths'

export interface ILayoutProps {
  header: React.ReactNode | React.ReactNode[]
  children: React.ReactNode | React.ReactNode[]
  isNarrow: boolean
}

const APP_NAME = 'YuMuuv'

const getStatisticsTabTitle = (tab?: string) => {
  switch (tab) {
    case 'fun-facts':
      return t`Fun facts`
    case 'top-100':
      return t`TOP 100`
    default:
      return t`Statistics`
  }
}

// Resolves a route definition to a human title. For routes whose title varies
// by URL param (e.g. /statistics/:tab), derive the right label here instead of
// using the static route title.
const resolveRouteTitle = (pathname: string): string => {
  const statisticsMatch = matchPath<{ tab?: string }>(pathname, { path: ROUTES.ADMIN_DASHBOARD_TAB.to, exact: true })
  if (statisticsMatch) return getStatisticsTabTitle(statisticsMatch.params.tab)

  const match = MAPPED_ROUTES.find((route) => matchPath(pathname, { path: route.to, exact: true }))
  return match?.title || match?.shortTitle || ''
}

// Sets document.title to "{route title} · YuMuuv" on every navigation so each
// page has a unique, descriptive title — satisfies WCAG 2.4.2 Page Titled.
// YumChallengeTitle further refines this with the actual challenge name once
// the goal data is loaded.
const PageTitle: React.FC = () => {
  const { pathname } = useLocation()
  React.useEffect(() => {
    const routeTitle = resolveRouteTitle(pathname)
    document.title = routeTitle ? `${routeTitle} · ${APP_NAME}` : APP_NAME
  }, [pathname])
  return null
}

export class Layout extends React.Component<ILayoutProps> {
  layoutContentBEM() {
    const classArray = ['layout__content', 'scrollable']

    /*if (this.props.isNarrow) {
      classArray.push('layout__content--narrow')
    }*/

    return classArray.join(' ')
  }

  scrollToTop = (event: { target: any; currentTarget: any }) => {
    if (['nav', 'layout__header'].includes(event.target.className)) scrollToTop()
  }

  render() {
    const { children, header } = this.props

    return (
      <div className="layout">
        <PageTitle />
        <div className="layout__inner">
          {/* `<header>` is a banner landmark when not nested inside main/article/aside/nav/section — */}
          {/* satisfies axe `region` rule (WCAG 2.4.1) so navbar + branding sit inside a named region. */}
          <header className="layout__header" onClick={this.scrollToTop}>
            {header}
          </header>
          <main id="content" role="main" tabIndex={-1} className={this.layoutContentBEM()}>
            {children}
          </main>
        </div>
      </div>
    )
  }
}
